import { Directive, HostListener, Renderer2 } from '@angular/core';

declare const event: any;

@Directive({
  selector: '[appRotateTooltip]'
})

export class RotateTooltipDirective  {

  private timer: any;
  private tooltip: any;
  private element: HTMLElement;

  constructor(private renderer: Renderer2) { }

  @HostListener('mouseover', ['event']) onMouseover() {
    this.element = event.fromElement;
    this.timer = setInterval(() => {
        this.tooltip = document.querySelector('.mat-tooltip');
        if (this.tooltip && this.element) {
          if (this.tooltip.getBoundingClientRect().top < this.element.getBoundingClientRect().top) {
            this.renderer.addClass(this.tooltip, 'arrowDown');
          } else {
            this.renderer.addClass(this.tooltip, 'arrowTop');
            this.clear();
          }
        }
      }, 160);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.element = null;
    clearInterval(this.timer);
    if (!this.tooltip) return;
    this.renderer.removeClass(this.tooltip, 'arrowTop');
    this.renderer.removeClass(this.tooltip, 'arrowDown');
  }

  clear() {
    clearInterval(this.timer);
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/shared/rotate-tooltip/rotate-tooltip.directive.ts